import { Component, OnInit } from '@angular/core';
import { LoaderService } from './services/common/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  isLoading = false;
  constructor(private readonly loaderService: LoaderService) { }

  ngOnInit() {
    this.loaderService.isLoading.subscribe(isLoading => this.isLoading = isLoading);
  }
}
